// extracted by mini-css-extract-plugin
export default {"container":"ck-z","blurb":"dk-z","links":"ek-z"};